export const PARAM_PAGE = "page";
export const PARAM_ORDER = "order";
export const PARAM_DELETED = "deleted";